/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { checkIsActive } from "../../../../_helpers";
import FilterToggle from "../../../../FilterToggle";

import {
  faUsers,
  faClipboardCheck,
  faPoll,
} from "@fortawesome/free-solid-svg-icons";

import { authSlice } from "../../../../../Store/modules/AuthModule/authSlice";
import { routers } from "../../../../../Constants/router_paths";

const { actions } = authSlice;

export function AsideMenuList({ layoutProps }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                home
              </span>
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/applications", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/applications">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                emoji_events
              </span>
            </span>
            <span className="menu-text">Applications List</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive(
            "/employer-profile",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/employer-profile">
            <span className="menu-icon">
              <span className="material-icons">perm_identity</span>
            </span>
            <span className="menu-text">Employer Profile</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}

        {/* Bootstrap */}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/events", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/events">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                today
              </span>
            </span>
            <span className="menu-text">View Events</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/messages", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/messages">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                chat
              </span>
            </span>
            <span className="menu-text">View Messages</span>
          </NavLink>
        </li> */}
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/* <li
          className={`menu-item ${getMenuItemActive("/account", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/account">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                account_circle
              </span>
            </span>
            <span className="menu-text">My Account</span>
          </NavLink>
        </li> */}
        <li
          className={`menu-item ${getMenuItemActive("/reportOverview", false)}`}
          aria-haspopup="true"
        >
          {/* <NavLink className="menu-link" to="/reportOverview">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                report
              </span>
            </span>
            <span className="menu-text">Reporting</span>
          </NavLink> */}
          <FilterToggle
            className="px-5 bg-transparent text2 border-0"
            icon={true}
          >
            <div className="px-5 ">
              <div className="px-5 py-2 sidebarDropDown">
                <NavLink className="menu-link" to="/reportoverview/coaches">
                  <div className="">Coaches</div>
                </NavLink>
                <NavLink className="menu-link" to="/reportoverview/job-seeker">
                  <div className="">Job Seeker</div>
                </NavLink>
              </div>
            </div>
          </FilterToggle>
        </li>
        {/* <li
          className={`menu-item ${getMenuItemActive("/subscription", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/subscription">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                card_membership
              </span>
            </span>
            <span className="menu-text">Subscription</span>
          </NavLink>
        </li> */}
        <li
          className={`menu-item ${getMenuItemActive("/programs", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/programs">
            <span className="menu-icon">
              <span className="material-icons material-icons-outlined">
                assignment
              </span>
            </span>
            <span className="menu-text">Programs</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
